<template>
  <v-container fluid>
    <v-card flat>
      <v-tabs v-model="tabSelected" right>
        <v-tab v-for="item in tabsItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabSelected">
        <v-tab-item v-for="item in tabsItems" :key="item">
          <v-card flat>
            <v-list>
              <template v-for="item in messages">
                <v-divider :key="item.name"></v-divider>
                <v-list-item :key="item.name" @click="listClick">
                  <v-row class="text-center">
                    <v-col cols="2">
                      <v-list-item-avatar>
                        <avatar
                          :username="item.name"
                          backgroundColor="#2196F3"
                          color="#fff"
                        />
                      </v-list-item-avatar>
                    </v-col>

                    <v-col cols="7" class="text-left d-flex align-center">
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-col>
                    <v-col
                      v-if="tabSelected === 2"
                      cols="3"
                      class="text-left d-flex align-center"
                    >
                      <div>{{ item.timeSpent }}</div>
                    </v-col>
                    <v-col
                      v-if="tabSelected === 1"
                      cols="3"
                      class="text-left d-flex align-center"
                    >
                      <div>{{ item.interactions }}</div>
                    </v-col>
                    <v-col
                      v-if="tabSelected === 0"
                      cols="3"
                      class="text-left d-flex align-center"
                    >
                      <div>{{ item.score }}%</div>
                      <!-- <v-list-item-title
                class="font-weight-green"
                color="green"
                v-text="item.score"
              ></v-list-item-title> -->
                    </v-col>
                  </v-row>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-divider></v-divider>
    </v-card>
  </v-container>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
  components: {
    Avatar
  },
  methods: {
    listClick(value) {}
  },
  data: () => ({
    tabSelected: 0,
    tabsItems: ['Score', 'interactions', 'Time Spent'],
    messages: [
      {
        position: 1,
        score: 92.5,
        name: 'felipe.prieto@trivantis.com',
        interactions: 230,
        timeSpent: '00:12:20'
      },
      {
        position: 2,
        score: 72.5,
        name: 'gmessler@saba.com',
        interactions: 230,
        timeSpent: '00:12:20'
      },
      {
        position: 3,
        score: 52.5,
        name: 'barri.schatten@trivantis.com',
        interactions: 230,
        timeSpent: '00:12:20'
      }
    ],
    lorem:
      'Lorem ipsum dolor sit amet, at aliquam vivendum vel, everti delicatissimi cu eos. Dico iuvaret debitis mel an, et cum zril menandri. Eum in consul legimus accusam. Ea dico abhorreant duo, quo illum minimum incorrupte no, nostro voluptaria sea eu. Suas eligendi ius at, at nemore equidem est. Sed in error hendrerit, in consul constituam cum.'
  })
}
</script>

<style>
.my-border {
  border-style: solid;
}
</style>
